/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_MessageInputs */

const en_delete_message = /** @type {(inputs: Delete_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Message`)
};

const id_delete_message = /** @type {(inputs: Delete_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus Pesan`)
};

/** @type {(inputs: Delete_MessageInputs) => LocalizedString} */
const es_delete_message = en_delete_message;

/** @type {(inputs: Delete_MessageInputs) => LocalizedString} */
const fr_delete_message = en_delete_message;

/** @type {(inputs: Delete_MessageInputs) => LocalizedString} */
const de_delete_message = en_delete_message;

/** @type {(inputs: Delete_MessageInputs) => LocalizedString} */
const ja_delete_message = en_delete_message;

/** @type {(inputs: Delete_MessageInputs) => LocalizedString} */
const zh_delete_message = en_delete_message;

/** @type {(inputs: Delete_MessageInputs) => LocalizedString} */
const ar_delete_message = en_delete_message;

/** @type {(inputs: Delete_MessageInputs) => LocalizedString} */
const it_delete_message = en_delete_message;

/** @type {(inputs: Delete_MessageInputs) => LocalizedString} */
const ru_delete_message = en_delete_message;

/** @type {(inputs: Delete_MessageInputs) => LocalizedString} */
const pt_delete_message = en_delete_message;

/** @type {(inputs: Delete_MessageInputs) => LocalizedString} */
const ko_delete_message = en_delete_message;

/**
* | output |
* | --- |
* | "Delete Message" |
*
* @param {Delete_MessageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delete_message = /** @type {((inputs?: Delete_MessageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_MessageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_message(inputs)
	if (locale === "es") return es_delete_message(inputs)
	if (locale === "fr") return fr_delete_message(inputs)
	if (locale === "de") return de_delete_message(inputs)
	if (locale === "ja") return ja_delete_message(inputs)
	if (locale === "zh") return zh_delete_message(inputs)
	if (locale === "ar") return ar_delete_message(inputs)
	if (locale === "id") return id_delete_message(inputs)
	if (locale === "it") return it_delete_message(inputs)
	if (locale === "ru") return ru_delete_message(inputs)
	if (locale === "pt") return pt_delete_message(inputs)
	return ko_delete_message(inputs)
});